import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { ChainGeneratedLegalDocumentsDto } from '../api/restApi';

export interface DocumentsState {
  legalDocuments?: ChainGeneratedLegalDocumentsDto;
}

const initialState: DocumentsState = {};

export const documentsSlice = createSlice({
  name: 'documents',
  initialState,

  reducers: {
    setLegalDocuments(state, { payload }: PayloadAction<ChainGeneratedLegalDocumentsDto>) {
      state.legalDocuments = payload;
    },
  },
});

export const { setLegalDocuments } = documentsSlice.actions;

export const documentsReducer = documentsSlice.reducer;
